module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "timeline-section"
  }, [_c('div', {
    staticClass: "inner-timeline"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("YouSound Partner Program Timeline")]), _vm._v(" "), _c('div', {
    staticClass: "timeline"
  }, [_c('div', {
    staticClass: "outer"
  }, _vm._l((_vm.timelines), function(timeline, i) {
    return _c('div', {
      key: i,
      staticClass: "card"
    }, [_c('div', {
      staticClass: "timeline-content"
    }, [_c('h3', {
      staticClass: "title"
    }, [_vm._v(_vm._s(timeline.date))]), _vm._v(" "), _c('p', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(timeline.title))]), _vm._v(" "), _vm._l((timeline.text), function(content, n) {
      return _c('p', {
        key: n,
        staticClass: "content"
      }, [_vm._v("\n              " + _vm._s(content) + "\n            ")])
    })], 2)])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bd0cd06","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing2/TimeLine.vue
// module id = 1686
// module chunks = 180